import { Injectable } from '@angular/core';
import { PostponedOrdersService } from '@core/services/postponed-orders.service';
import {
  Action, Selector, State, StateContext,
} from '@ngxs/store';
import { Observable, tap } from 'rxjs';
import { GetPostponedOrdersCount } from '../action/postponed-orders.action';

export interface PostponedOrdersStateModel {
  count: number;
}

@State<PostponedOrdersStateModel>({
  name: 'PostponedOrdersState',
  defaults: {
    count: 0,
  },
})
@Injectable()
export class PostponedOrdersState {
  constructor(private readonly postponedOrdersService: PostponedOrdersService) {}

  @Selector()
  public static getCount(state: PostponedOrdersStateModel): number {
    return state.count;
  }

  @Action(GetPostponedOrdersCount)
  public getPostponedOrdersCount(ctx: StateContext<PostponedOrdersStateModel>): Observable<number> {
    return this.postponedOrdersService.getPostponedOrdersCount().pipe(tap((count) => ctx.patchState({ count })));
  }
}
